import React from 'react';
interface ToggleProps {
  id: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  description?: string;
}
export const Toggle: React.FC<ToggleProps> = ({
  id,
  label,
  checked,
  onChange,
  description
}) => {
  return <div className="flex items-center justify-between" data-id="element-11467">
      <div className="pr-4" data-id="element-11468">
        <p className="font-medium text-gray-800 dark:text-white" data-id="element-11469">{label}</p>
        {description && <p className="text-sm text-gray-700 dark:text-gray-400" data-id="element-11470">
            {description}
          </p>}
      </div>
      <label className="relative inline-flex items-center cursor-pointer" aria-pressed={checked} data-id="element-11471">
        <input type="checkbox" id={id} className="sr-only peer" checked={checked} onChange={e => onChange(e.target.checked)} data-id="element-11472" />
        <div className="w-11 h-6 bg-gray-300 dark:bg-gray-600 peer-checked:bg-deep-pink rounded-full relative" data-id="element-11473">
          <div className="h-5 w-5 bg-white rounded-full absolute left-0.5 top-0.5 transition-transform duration-300 peer-checked:translate-x-5" data-id="element-11474"></div>
        </div>
      </label>
    </div>;
};